<template>
	<div id="about">
		<div class="content">
			<title-hero Heading="" SubHeading="" Short="true"
				:Video="require('@/assets/PeeledOrange.mp4')"
				:MobileVideo="require('@/assets/PeeledOrange_Mobile.mp4')"
			/>
			<div class="about-content">
				<h1>Money Guided</h1>
				<h2>Opening Email</h2>
				<p>Your email to {{ to }} should open now. If not, <a :href="mailto">tap here</a>.</p>
			</div>
		</div>
	</div>
</template>

<script>

import TitleHero from "./TitleHero.vue";
export default {
	components: { TitleHero },
	computed: {
		to: function(){ return this.$route.query.to || ''; },
		mailto: function(){
			// Rebuilt from decoded query values, so the CMS can hold readable text
			var parts = [];
			if (this.$route.query.subject) parts.push('subject=' + encodeURIComponent(this.$route.query.subject));
			if (this.$route.query.body) parts.push('body=' + encodeURIComponent(this.$route.query.body));
			return 'mailto:' + this.to + (parts.length ? '?' + parts.join('&') : '');
		},
	},
	methods: {
		launch: function(){
			if (this.to) window.location = this.mailto;
		},
	},
	mounted: function() { this.launch(); }
}

</script>

<style scoped>
	h1 {
		margin-top: 50px;
		text-align: left;
		margin-bottom: 30px;
		font-size: 25px;
		font-weight: bold;
	}
	h2 {
		font-size: 20px;
		margin-bottom: 30px;
		text-align: left;
	}
	p {
		text-align: left;
	}
	.about-content {
		width: 47%;
		min-width: 300px;
		margin-left: auto;
		margin-right: auto;
		padding-bottom: 50px;
	}
</style>
